import CheckBox from "./CheckBox";
import TextField from "./TextField";
import Select from "./Select";
var Iputs = {
  CheckBox: CheckBox,
  TextField: TextField,
  Select: Select
};
export default Iputs;